import React from 'react';

const LicenseAndCertificationsForm = () => {
    return <></>;
};

export default LicenseAndCertificationsForm;
